/* ============================================================================
   cleanse3-offer.js
   Painter of the offer box on templates/product.cleanse3.json. It is the buy-box
   part of assets/cleanselander-broad.js (the pad lander's script), unchanged in
   behaviour, scoped to the box (#cl3Offer) and its two popups:
     - paints the cards, the labels, the button price and the Auto Refills tile
       from window.CLEANSE (snippets/cleanse3-offer.liquid prints it);
     - the plan tiles and the offer cards (one state object, the DOM follows it);
     - the "Click To See Why" popup and the Dosing guide popup;
     - the trust line that stacks when its halves would wrap.
   Add To Cart is NOT here: the inline script in the snippet owns it, so the button
   works before this file loads.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__cl3Painter) return;
  window.__cl3Painter = true;

  function boot() {
    var CLEANSE = window.CLEANSE;
    var BOX = document.getElementById('cl3Offer');
    if (!CLEANSE || !CLEANSE.offers || !BOX) return;
    var sel = { offer: CLEANSE.defaultOffer, plan: CLEANSE.hasPlans ? 'sub' : 'otp' };

    function qs(s, r) { return (r || BOX).querySelector(s); }
    function qsa(s, r) { return Array.prototype.slice.call((r || BOX).querySelectorAll(s)); }
    function byId(id) { return document.getElementById(id); }
    function setText(id, v) { var el = byId(id); if (el && el.textContent !== String(v)) el.textContent = v; }
    var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* The popups live at the end of <body>: a theme wrapper with a transform or an
       overflow rule must not clip or offset a fixed overlay. */
    ['hlpOfferModal', 'hlpModal'].forEach(function (id) {
      var m = byId(id);
      if (m && m.parentNode !== document.body) document.body.appendChild(m);
    });

    // ---- labels, cards and button, all painted from CLEANSE ----
    function money(n) { return CLEANSE.money(n); }
    /* Per-bottle display (Ariel 10/16): every card and the button show the price per bottle,
       floored to the cent (149.99 / 6 = 24.99). Billing is unchanged: the pack's own price. */
    function per(n, o) { var c = Math.floor(Math.round(n * 100) / (o.bottles || 1)); if (c % 100 !== 99) c = Math.floor(c / 100) * 100 - 1; return c / 100; }
    function priceOf(o) { return sel.plan === 'sub' && CLEANSE.hasPlans && o.sub ? o.sub : o.otp; }
    function renderLabels() {
      var o = CLEANSE.offers[sel.offer];
      if (!o) return;
      setText('hlpOfferLabel', o.title);
      setText('hlpPlanLabel', CLEANSE.planLabels[sel.plan]);
      setText('hlpAtcLabel', 'Add To Cart');
      var w = (CLEANSE.why || {})[sel.offer];
      if (w) {
        setText('hlpOfferWhyLine', w.line); setText('hlpOfferWhyTitle', w.title);
        var wb = byId('hlpOfferWhyBody');
        if (wb) { wb.textContent = ''; w.paras.forEach(function (t) { var p = document.createElement('p'); p.textContent = t; wb.appendChild(p); }); }
      }
      // the Auto Refills tile states what the selected pack saves against buying it once
      if (o.sub && o.otp > o.sub) setText('hlpPlanSave', 'Save ' + Math.round((1 - o.sub / o.otp) * 100) + '%');
    }
    function renderOffers() {
      qsa('.ob2-offer').forEach(function (card) {
        var o = CLEANSE.offers[card.getAttribute('data-offer')];
        if (!o) return;
        var price = priceOf(o), saves = o.compare > price;
        var put = function (q, v, show) {
          var el = card.querySelector(q);
          if (!el) return;
          if (el.textContent !== v) el.textContent = v;
          el.style.display = show === false ? 'none' : '';
        };
        var pe = card.querySelector('.ob2-offer-price');
        if (pe) { var ph = money(per(price, o)) + '<span class="ob2-per">/bottle</span>'; if (pe.innerHTML !== ph) pe.innerHTML = ph; }
        put('.ob2-compare-price', saves ? money(per(o.compare, o)) : '', saves);
        put('.ob2-saving-tag', saves ? 'You save ' + Math.round((1 - price / o.compare) * 100) + '%' : '', saves);
      });
      renderLabels();
    }
    // The DOM follows the one state object, never the other way round.
    function syncSelection() {
      qsa('.ob2-offer').forEach(function (c) {
        var on = c.getAttribute('data-offer') === sel.offer;
        c.classList.toggle('is-on', on); c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      qsa('.ob2-plan').forEach(function (c) {
        var on = c.getAttribute('data-plan') === sel.plan;
        c.classList.toggle('is-on', on); c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    function update() { renderOffers(); }
    // No plan found: plan step hidden, one-time prices, the offer step is step 1.
    // Plans found: plan step shown with Auto Refills selected, the offer step is step 2.
    function applyPlanState() {
      var on = !!CLEANSE.hasPlans;
      var planBlock = byId('hlpPlanBlock');
      // a shopper who already chose One Time on a plan step that was on screen keeps it
      var keepOtp = on && planBlock && !planBlock.hidden && sel.plan === 'otp';
      if (planBlock) planBlock.hidden = !on;
      var offerBlock = byId('hlpOfferBlock');
      if (offerBlock) {
        offerBlock.style.marginTop = on ? '40px' : '';
        offerBlock.style.borderTop = on ? '1px solid #BFE5B8' : '';
        offerBlock.style.paddingTop = on ? '40px' : '32px';
      }
      var stepWrap = byId('hlpOfferStepWrap');
      if (stepWrap) stepWrap.hidden = !on;
      setText('hlpOfferStep', '2');
      sel.plan = on && !keepOtp ? 'sub' : 'otp';
      syncSelection();
      update();
    }

    // ---- ATC pulse ----
    var pulseT;
    function bump() {
      var atc = byId('addToCartBtn');
      if (!atc || atc.disabled || REDUCED) return;
      clearTimeout(pulseT);
      atc.classList.remove('is-pulse');
      void atc.offsetWidth;
      atc.classList.add('is-pulse');
      pulseT = setTimeout(function () { atc.classList.remove('is-pulse'); }, 2400);
    }

    // ---- "Click To See Why" popup (the lander's setupModal) ----
    function setupModal(modalId, openBtnId, closeBtnId) {
      var modal = byId(modalId);
      var openBtn = byId(openBtnId);
      var closeBtn = byId(closeBtnId);
      if (!modal) return;
      var scrollPos = 0;
      function open() {
        scrollPos = window.pageYOffset;
        modal.classList.add('show');
        document.body.style.position = 'fixed';
        document.body.style.top = -scrollPos + 'px';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      }
      function close() {
        if (!modal.classList.contains('show')) return;
        modal.classList.remove('show');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollPos);
      }
      if (openBtn) {
        openBtn.addEventListener('click', open);
        openBtn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
      }
      if (closeBtn) closeBtn.addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Esc') close(); });
    }

    // ---- Dosing guide popup (the lander's openModal('size') / closeModal) ----
    function openDose() {
      var overlay = byId('hlpModal');
      var boxEl = byId('hlpModalBox');
      if (!overlay || !boxEl) return;
      Array.prototype.slice.call(overlay.querySelectorAll('img[data-hlp-src]')).forEach(function (img) {
        img.src = img.getAttribute('data-hlp-src');
        img.removeAttribute('data-hlp-src');
      });
      overlay.style.display = 'flex';
      boxEl.scrollTop = 0;
      requestAnimationFrame(function () { overlay.style.opacity = 1; });
      document.body.style.overflow = 'hidden';
    }
    function closeDose() {
      var overlay = byId('hlpModal');
      if (!overlay || overlay.style.display === 'none' || !overlay.style.display) return;
      overlay.style.display = 'none';
      overlay.style.opacity = 0;
      document.body.style.overflow = '';
    }

    // ---- trust line: stack the two halves when they would wrap ----
    function trustSep() {
      var row = qs('.post-purchase-info');
      if (!row) return;
      row.classList.remove('is-stacked');
      var halves = qsa('.pp-trust-half', row);
      if (halves.length < 2) return;
      var wrapped = Math.abs(halves[0].getBoundingClientRect().top - halves[1].getBoundingClientRect().top) > 4;
      if (wrapped) row.classList.add('is-stacked');
    }

    // ---- selectors (delegated per group) ----
    function wireGroup(rowId, optSelector, attr, prop, after) {
      var row = byId(rowId);
      if (!row) return;
      function choose(opt) {
        qsa(optSelector, row).forEach(function (x) { x.classList.remove('is-on'); });
        opt.classList.add('is-on');
        sel[prop] = opt.getAttribute(attr);
        syncSelection();
        update();
        bump();
        if (after) after();
      }
      row.addEventListener('click', function (e) {
        var opt = e.target.closest(optSelector);
        if (!opt || !row.contains(opt)) return;
        choose(opt);
      });
      row.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        var opt = e.target.closest(optSelector);
        if (!opt || !row.contains(opt)) return;
        e.preventDefault();
        choose(opt);
      });
    }
    wireGroup('hlpPlanRow', '.ob2-plan', 'data-plan', 'plan');
    wireGroup('hlpOfferRow', '.ob2-offer', 'data-offer', 'offer', function () {
      var btn = byId('addToCartBtn');
      if (!btn) return;
      setTimeout(function () {
        btn.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
        btn.classList.remove('is-pulse');
        void btn.offsetWidth;
        btn.classList.add('is-pulse');
      }, 150);
    });

    setupModal('hlpOfferModal', 'offerInfoLink', 'hlpOfferModalClose');
    var sg = byId('hlpSizeGuide');
    if (sg) {
      sg.addEventListener('click', openDose);
      sg.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openDose(); } });
    }
    var dc = byId('hlpModalClose');
    if (dc) dc.addEventListener('click', closeDose);
    var dov = byId('hlpModal');
    if (dov) dov.addEventListener('click', function (e) { if (e.target === dov) closeDose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Esc') closeDose(); });

    // ---- the theme's sticky bar ----
    // In "after scroll" mode the theme shows its bar (inline transform: none) once the
    // theme's own buy button has scrolled past. This template has no theme buy button,
    // so the offer box's button drives it: the bar shows once that button is above the
    // screen and hides again when the shopper scrolls back up to the box. Its press
    // scrolls to the box (assets/furbos-cleanse3.js).
    (function () {
      var bar = document.querySelector('sticky-atc[data-after-scroll]');
      var atc = byId('addToCartBtn');
      if (!bar || !atc || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.style.transform = past ? 'none' : '';
      }).observe(atc);
    })();

    var tT;
    window.addEventListener('resize', function () { clearTimeout(tT); tT = setTimeout(trustSep, 120); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(trustSep, 0); });
    trustSep();

    // initial state: paint from CLEANSE, then again once the product JSON is back
    syncSelection();
    update();
    if (CLEANSE.ready && CLEANSE.ready.then) CLEANSE.ready.then(applyPlanState);

    window.__cl3 = { sel: sel, update: function () { syncSelection(); update(); } };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
